import styled, { css } from "styled-components";

export const StyledWhy = styled.div`
    background: ${p => p.theme.c.light};
    position: relative;
    h2 {
        font-size: 38px;
        text-transform: uppercase;
        text-align: center;

        ${p =>
            p.theme.md.only(css`
                font-size: 32px;
            `)}

        ${p =>
            p.theme.sm.max(css`
                font-size: 30px;
                margin-bottom: 10px;
            `)}
    }


    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 300;
    color: ${p => p.theme.c.boost};
    box-shadow: 0 -8px 6px -4px ${p => p.theme.c.blackShadow2};

    ${p =>
        p.theme.sm.max(css`
            padding-bottom: 12px;
        `)}

    p {
        margin: auto;
        padding: 0 0 12px;
        line-height: 1.5;
        text-align: center;
        ${p =>
            p.theme.md.min(css`
                width: 850px;
            `)}



        ${p =>
            p.theme.sm.max(css`
                padding: 0 16px;
                font-size: 18px;
                text-align: justify;
            `)}
        ${p =>
            p.theme.sm.only(css`
                text-align: center;
            `)}
        ${p =>
            p.theme.md.only(css`
                font-size: 20px;
            `)}

        ${p =>
            p.theme.xs(css`
                br {
                    display: none;
                }
                hyphens: manual;
            `)}

    }
`;
